import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Logo } from '../components/Brand';

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const [details, setDetails] = useState(null);
  const sessionId = params.get('session_id');
  const provider = params.get('provider');
  const bookingId = params.get('booking_id');
  const isMembership = params.get('membership') === '1';
  const posOrderId = params.get('pos_order_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/stripe/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === 'paid') { setStatus('paid'); toast.success('Payment confirmed!'); return; }
        if (data.status === 'expired') { setStatus('expired'); return; }
        if (attempts++ < 8) setTimeout(poll, 2000); else setStatus('timeout');
      } catch (err) { setStatus('error'); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className='min-h-screen flex items-center justify-center bg-[#FFF8F2] p-6'>
      <Card className='w-full max-w-lg p-8 shadow-xl border border-slate-200 text-center'>
        <div className='flex justify-center mb-4'><Logo /></div>
        {status === 'checking' && (
          <>
            <Loader2 className='w-12 h-12 text-[#1B3A87] mx-auto animate-spin' />
            <h2 className='font-display text-2xl font-bold mt-4'>Confirming your payment…</h2>
            <p className='text-slate-500 text-sm mt-2'>This usually takes a few seconds.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <CheckCircle2 className='w-14 h-14 text-[#167A5A] mx-auto' />
            <h2 className='font-display text-2xl font-bold mt-4 text-[#0B1220]'>Payment successful</h2>
            <p className='text-slate-600 mt-2'>{isMembership ? 'Welcome to JFK9 VIP membership!' : posOrderId ? 'POS order paid.' : 'Your boarding booking is confirmed.'}</p>
            {details && <div className='mt-4 text-sm font-mono text-slate-500'>Session: {sessionId?.substring(0, 20)}…</div>}
            <Button className='mt-6 bg-[#1B3A87] hover:bg-[#16306F] text-white' onClick={() => navigate(bookingId ? '/client/bookings' : posOrderId ? '/admin/pos' : '/client')} data-testid='payment-success-continue'>Continue</Button>
          </>
        )}
        {(status === 'expired' || status === 'timeout' || status === 'error') && (
          <>
            <XCircle className='w-14 h-14 text-[#B42318] mx-auto' />
            <h2 className='font-display text-2xl font-bold mt-4 text-[#0B1220]'>Could not confirm payment</h2>
            <p className='text-slate-600 mt-2'>{status === 'expired' ? 'Your session expired.' : 'Please refresh or contact support.'}</p>
            <Button className='mt-6' variant='outline' onClick={() => navigate('/client')}>Back to Dashboard</Button>
          </>
        )}
      </Card>
    </div>
  );
}
